module.exports = __webpack_public_path__ + "static/media/花泽香菜教你日语五十音.bb211d8e.png";